export const ENV = () => {
    return {
        BASE_URL: 'https://preprod-gateway.bitazzax.com/api',
        ICON_URL: 'https://assets.bitazzax.com/icons',
        WEB_TRADE: 'https://preprod-revamped-trade.bitazza.com',
    }
}
//TODO
// BASE_URL: 'https://preprod-gateway.bitazza.com/api',
// ICON_URL: 'https://assets.bitazza.com/icons',
